module.exports = __webpack_public_path__ + "static/media/category0.9e6f0c17.png";